import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { State } from '../../../typings/state';
import { TDispatchProps, TStateProps } from '../../../typings/utils';
import {
    AddCreativeAction,
    createOverlay,
    initOverlayData,
    optionChange,
    saveName,
    toggleOptionGroupVisibility
} from '../actions';
import { selectOverlayCreativeState } from '../selectors';

import { AddOverlayCreative, AddOverlayCreativeProps } from './AddOverlayCreative';

export type StateProps = TStateProps<AddOverlayCreativeProps>;

export type DispatchProps = TDispatchProps<AddOverlayCreativeProps, OwnProps>;

type OwnProps = {
    onCancel: () => void;
    creativesSelect: (ids: number[]) => void;
};

export const mapStateToProps = (state: State): StateProps => {
    const {
        isLoading,
        isSaving,
        creativeOptions,
        error,
        pcodeVideoPreviewData,
        isPreviewLoading,
        submitEnabled
    } = selectOverlayCreativeState(state.canvasEditor.canvas.addCreative);

    return {
        isLoading,
        isSaving,
        creativeOptions,
        error,
        videoPreviewData: pcodeVideoPreviewData,
        isPreviewLoading,
        submitEnabled
    };
};

const mapDispatchToProps = (dispatch: Dispatch<AddCreativeAction>, ownProps: OwnProps): DispatchProps => {
    return {
        onOptionChange: (groupName: string, name: string, value: string): void => {
            dispatch(optionChange(groupName, name, value));
        },
        onGroupVisibleChange: (groupName: string): void => {
            dispatch(toggleOptionGroupVisibility(groupName));
        },
        onSaveName: (name: string): void => {
            dispatch(saveName(name));
        },
        onSave: (): void => {
            dispatch(createOverlay(ownProps.creativesSelect));
        },
        initVideoData: (): void => {
            dispatch(initOverlayData());
        }
    };
};

const mergeProps = (
    stateProps: StateProps,
    dispatchProps: DispatchProps,
    ownProps: OwnProps
): AddOverlayCreativeProps => {
    const { creativesSelect, ...otherProps } = ownProps;

    return {
        ...stateProps,
        ...dispatchProps,
        ...otherProps
    };
};

export const AddOverlayCreativeContainer = connect<StateProps, DispatchProps, OwnProps, AddOverlayCreativeProps>(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(AddOverlayCreative);
